import { render, staticRenderFns } from "./BoardOfRevision.vue?vue&type=template&id=603e5c7d&"
import script from "./BoardOfRevision.vue?vue&type=script&lang=js&"
export * from "./BoardOfRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports